import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StickySpacerDirective } from './sticky-spacer.directive';
import { StickyDirective } from './sticky.directive';


@NgModule({
    declarations: [
        StickyDirective,
        StickySpacerDirective
    ],
    imports: [
        CommonModule
    ],
    exports: [
        StickyDirective,
        StickySpacerDirective
    ]
})
export class StickyModule {
}
